<template>
  <div class="menu_container">
    <div class="headLine">
      <img src="./HyNumberSearch/leftAngle.png" alt="返回首页" @click="backIndex" />
      库存预警清单-化验电子管理系统
    </div>
    <!-- 菜单容器 -->
    <div class="codeBox">
      <div class="codeTil">库存预警明细</div>
      <div class="codeList">
        <div class="codeLeft">物品名称</div>
        <div class="codeRight">{{ dataForm.goodsName }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">仓库名</div>
        <div class="codeRight">{{ dataForm.warehouseName }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">货位名</div>
        <div class="codeRight">{{ dataForm.shelvesName }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">生产厂家</div>
        <div class="codeRight">{{ dataForm.suppliersName }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">物品颜色</div>
        <div class="codeRight">{{ dataForm.goodsColor }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">物品规格</div>
        <div class="codeRight">{{ dataForm.goodsSpecification }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">物品类别</div>
        <div class="codeRight">{{ dataForm.goodsCategory }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">物品浓度</div>
        <div class="codeRight">{{ dataForm.goodsConcentration }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">现有库存</div>
        <div class="codeRight">{{ dataForm.qty }}</div>
      </div>
      <div class="codeList">
        <div class="codeLeft">状态</div>
        <div class="codeRight">
          <el-tag v-if="dataForm.status === 0">待采购</el-tag>
          <el-tag v-else type="success">采购完成</el-tag>
        </div>
      </div>
      <div class="codeList">
        <div class="codeLeft">备注</div>
        <div class="codeRight">{{ dataForm.remarks }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return{
      popstateLock: 0,//是否监听物理返回键
      dataForm: {
        id: 0,
        suppliersId: 0,
        goodsId: 0,
        goodsName: "",
        qty: 0,
        goodsSpecificationId: 0,
        goodsColorId: null,
        warehouseId: 0,
        shelvesId: 0,
        goodsConcentrationId: null,
        goodsCategoryId: 0,
        remarks: null,
        status: 0,
        suppliersName: null,
        shelvesName: null,
        warehouseName: null
      }
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.getDataList();
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //把导航路由辨别码转成整形
      if (!this.id) {
        //在没有传id的情况下，就是在系统首页，这个时候调用微信WeixinJSBridgeReady自带的API对返回键进行监听实现在首页返回关闭页面
        document.addEventListener("WeixinJSBridgeReady", function() {
          window.WeixinJSBridge.call("closeWindow");
        }, false);
        window.WeixinJSBridge.call("closeWindow");
      } else {
        //判断物理返回键是否监听
        if (!this.popstateLock) {
          window.history.pushState(null, null, '#')
        }
      }
    },
    // 返回首页
    backIndex() {
      this.$router.replace({ name: 'hyPage' })
    },
    // 获取数据
    getDataList() {
      let id = parseInt(this.$route.query.id);
      console.log(id)
    },
  },
}
</script>

<style lang="scss" scoped>
.menu_container {
  font-size: 16px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .codeBox {
    position: relative;
    margin: 70px 18px 30px;
    display: flex;
    flex-wrap: wrap;
    border: 2px #efefef solid;
    .codeTil {
      flex: 0 0 100%;
      font-size: 18px;
      text-align: center;
      padding: 1em 0;
      border-bottom: 2px #efefef solid;
    }
    .codeList {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      flex: 0 0 100%;
      border-bottom: 2px #efefef solid;
      .codeLeft {
        font-size: 14px;
        color: #000;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        width: 80px;
        border-right: 2px #efefef solid;
      }
      .codeRight {
        flex: 1;
        padding: 8px;
        font-size: 14px;
        color: #666;
        min-height: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      &:last-child {
        border-bottom:  none;
      }
    }
  }
  .menuBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 70px 20px 20px;
    .boxList {
      display: flex;
      flex-direction: column;
      width: 45%;
      border-radius: 6px;
      text-align: center;
      margin-bottom: 20px;
      padding: 0 0 25px;
      position: relative;
      img {
        margin: 20px auto;
        height: 60px;
      }
      p {
        display: block;
        color: #F3F8F3;
        padding: 0;
        margin: 0;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .box01,
    .box07{
      background-color: #36AB60;
    }
    .box02,
    .box08 {
      background-color: #E98F36;
    }
    .box03,
    .box09 {
      background-color: #D81E06;
    }
    .box04, .box10 {
      background-color: #A4579D;
    }
    .box05, .box11 {
      background-color: #1195DB;
    }
    .box06, .box12 {
      background-color: #d0c605;
    }
  }
}
</style>
